import { render, staticRenderFns } from "./CreateUsersFromWP.vue?vue&type=template&id=5d8557fe&"
import script from "./CreateUsersFromWP.vue?vue&type=script&lang=js&"
export * from "./CreateUsersFromWP.vue?vue&type=script&lang=js&"
import style0 from "./CreateUsersFromWP.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports